import React, {useEffect, useState, useRef} from 'react'
import HTMLFlipBook from "react-pageflip"
import img01 from '../img/hocbong/img1.png'
import img02 from '../img/hocbong/img2.png'
import img03 from '../img/hocbong/img3.png'
import img04 from '../img/hocbong/img4.png'
import img05 from '../img/hocbong/img5.png'
import img06 from '../img/hocbong/img6.png'
import img07 from '../img/hocbong/img7.png'
import img08 from '../img/hocbong/img8.png'
import img09 from '../img/hocbong/img9.png'
import img10 from '../img/hocbong/img10.png'
import img11 from '../img/hocbong/img11.png'
import img12 from '../img/hocbong/img12.png'
import img13 from '../img/hocbong/img13.png'
import img14 from '../img/hocbong/img14.png'
import img15 from '../img/hocbong/img15.png'
import img16 from '../img/hocbong/img16.png'
import img17 from '../img/hocbong/img17.png'
import img18 from '../img/hocbong/img18.png'
import img19 from '../img/hocbong/img19.png'
import img20 from '../img/hocbong/img20.png'
import img21 from '../img/hocbong/img21.png'
import img22 from '../img/hocbong/img22.png'
import img23 from '../img/hocbong/img23.png'
import img24 from '../img/hocbong/img24.png'
import img25 from '../img/hocbong/img25.png'
// import img26 from '../img/hocbong/img26.png'
// import img27 from '../img/hocbong/img27.png'
import { FaCircleChevronRight, FaCircleChevronLeft} from "react-icons/fa6";
  
export default function Hocbong({objectProp}) {
    const image = [img01, img02, img02, img03, img04, img05, img06, img07, img08, img09, img10,
        img11, img12, img13, img14, img15, img16, img17, img18, img19, img20, img21, img22, img23, img24, img25]
    
    const flipBookRef = useRef(null)

    const nextButtonClick = () => {
        if (flipBookRef.current) {
            flipBookRef.current.pageFlip().flipNext();
        }
    }
    
    const prevButtonClick = () => {
        if (flipBookRef.current) {
            flipBookRef.current.pageFlip().flipPrev();
        }
    }

  return (
    <div className="overflow-hidden bg-gradient-to-r from-cyan-500 to-blue-500 w-screen h-screen flex items-center">
        <div className={objectProp.isMobile?
            "m-auto w-auto h-auto relative"
            :objectProp.isTablet?"m-auto w-[80%] h-auto relative"
            :objectProp.isTabletBig?"m-auto w-[80%] h-auto relative"
            :objectProp.isPCBig?"m-auto w-[60%] h-auto relative"
            :"m-auto w-[55%] h-auto relative flex items-center"
            }>
        <FaCircleChevronLeft onClick={prevButtonClick} size={objectProp.isPCBig?"40px":"35px"} color='#fff' className={objectProp.isMobile?
            "mr-[100px] absolute bottom-[-80px] left-[100px] translate-y-[-50%] cursor-pointer opacity-[0.8] hover:opacity-[1] z-[100]"
            :objectProp.isTablet? "mr-[100px] absolute bottom-[-65px] left-[240px] translate-y-[-50%] cursor-pointer opacity-[0.8] hover:opacity-[1] z-[100]"
            :objectProp.isPCBig? "mr-[100px] absolute top-[50%] left-[-80px] translate-y-[-50%] cursor-pointer opacity-[0.8] hover:opacity-[1] z-[100]"
            :"mr-[100px] absolute top-[50%] left-[-60px] translate-y-[-50%] cursor-pointer opacity-[0.8] hover:opacity-[1] z-[100]"
            } />

            <HTMLFlipBook size={objectProp.isMobile?"fixed":"stretch"} width={320} height={415} className="m-auto cursor-pointer shadow-[]" ref={flipBookRef}>
                {
                    image.map((img, index)=>{
                        return <div key={index} className="demoPage">
                                <img src={img} className="w-full h-full rounded-[3px]" />
                            </div>
                    })
                }
            </HTMLFlipBook>

            <FaCircleChevronRight onClick={nextButtonClick} size={objectProp.isPCBig?"40px":"35px"} color='#fff' className={objectProp.isMobile?
                "mr-[100px] absolute bottom-[-80px] right-[10px] translate-y-[-50%] cursor-pointer opacity-[0.8] hover:opacity-[1] z-[100]"
                :objectProp.isTablet? "mr-[100px] absolute bottom-[-65px] right-[140px] translate-y-[-50%] cursor-pointer opacity-[0.8] hover:opacity-[1] z-[100]"
                :objectProp.isPCBig?"mr-[100px] absolute top-[50%] right-[-180px] translate-y-[-50%] cursor-pointer opacity-[0.8] hover:opacity-[1] z-[100]"
                :"mr-[100px] absolute top-[50%] right-[-160px] translate-y-[-50%] cursor-pointer opacity-[0.8] hover:opacity-[1] z-[100]"
                } />
        </div>
    </div>
  )
}
